<script setup>
const { $pwa } = useNuxtApp()
</script>

<template>
  <Transition name="slide-fade-up">
    <div v-show="$pwa.needRefresh">
      <span> New content available, click the reload button to update.</span>
      <button
        class="compact button button--secondary button--lg justify-center"
        @click="$pwa.updateServiceWorker()"
      >
        Reload
      </button>
    </div>
  </Transition>
</template>

<style scoped>
div {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #4a4a4a;
  color: #fff;
  text-align: center;
  padding: 1rem;
  z-index: 9997;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.slide-fade-up-enter-active,
.slide-fade-up-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-up-enter-from,
.slide-fade-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
